module.exports = __webpack_public_path__ + "img/sw.9c49a237.png";